export default __webpack_public_path__ + "static/media/deposit-success-image.130ca1e4.svg";